import { render, staticRenderFns } from "./BookingButton.vue?vue&type=template&id=0091ae56&scoped=true&lang=pug&"
import script from "./BookingButton.vue?vue&type=script&lang=js&"
export * from "./BookingButton.vue?vue&type=script&lang=js&"
import style0 from "./BookingButton.vue?vue&type=style&index=0&id=0091ae56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0091ae56",
  null
  
)

export default component.exports